<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rMRAQE/tc-custom/9780374721527.jpg?1733023820235" alt="This image is the cover for the book Lantern Slides"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lantern Slides
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Winner of the<i> Los Angeles Times </i>Book Prize for Fiction</b><br/><br/>“Superb...[<i>Lantern Slides</i>] continues the quest for origin and explanation that has preoccupied O’Brien...Her stories unearth the primeval feelings buried just below the surface of nostalgia, using memories to illuminate both what is ridiculous and what is heroic about passion.”<b> —David Leavitt, <i>The New York Times Book Review</i></b><br/><br/>“Her stories are brilliantly realized and often very funny...O’Brien is quite simply one of the finest short story writers of our time.” <b>—Joyce Carol Oates</b><br/><br/>A newly reissued collection of stories from the author of <i>Girl</i>, “one of the most celebrated writers in the English language” (NPR’s <i>Weekend Edition</i>)<br/><br/>In twelve stories peopled with deeply etched characters, whom we come to know instantly and intimately, <i>Lantern Slides</i> reveals the wit and passion of a master of the short fiction form. Rich and humorous, full of struggle and boldness, these stories are a singular reflection of Edna O’Brien’s artistry.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edna O'Brien
      </h2>
      
      <p class="authorDescription body article"><B>Edna O’Brien</B> (1930–2024) was the author of more than twenty-five works of fiction, including <I>The Country Girls</I>, <I>The Little Red Chair</I>s, and <I>The Light of Evening</I>. She received numerous awards, including the PEN/Nabokov Award for Achievement in International Literature, the Irish PEN Award for Literature, the National Arts Club Medal of Honor, and the Ulysses Medal. Born and raised in the west of Ireland, she lived in London for many years.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Picador
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?302a268b